import { Component, DestroyRef, OnInit } from '@angular/core';
import { CompanyService } from 'src/app/services/companies-services/company.service';
import { tap } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ProductModel } from 'src/app/models/product.model';
import { ApplicationModel } from 'src/app/models/application.model';
import { CenterTypeModel } from 'src/app/models/centertype.model';
import { TIMEZONES } from 'src/assets/timezones/timezones';

@Component({
    selector: 'app-companies-new-company-dashboard',
    templateUrl: './companies-new-company-dashboard.component.html',
    styleUrls: ['./companies-new-company-dashboard.component.scss'],
    standalone: false
})
export class CompaniesNewCompanyDashboardComponent implements OnInit {

  countries: string[];
  products: ProductModel[];
  applications: ApplicationModel[];
  centerTypes: CenterTypeModel[];
  timezones;

  constructor(
    private companyService: CompanyService,
    private destroyRef: DestroyRef
  ) { 
    this.timezones = TIMEZONES;
  }

  ngOnInit() {
    this.getCompanyCountries();
    this.getProductList();
    this.getApplicationList();
    this.getCenterTypeList();
  }

  public getCompanyCountries() {
    this.companyService.getCompanyCountries().pipe(
      takeUntilDestroyed(this.destroyRef),
      tap(res => this.countries = res)
    ).subscribe();
  }

  public getProductList() {
    this.companyService.getProductList().pipe(
      takeUntilDestroyed(this.destroyRef),
      tap((res: ProductModel[]) => this.products = res)
    ).subscribe();
  }

  public getApplicationList() {
    this.companyService.getApplicationList().pipe(
      takeUntilDestroyed(this.destroyRef),
      tap((res: ApplicationModel[]) => this.applications = res)
    ).subscribe();
  }

  public getCenterTypeList() {
    this.companyService.getCenterTypeList().pipe(
      takeUntilDestroyed(this.destroyRef),
      tap((res: CenterTypeModel[]) => this.centerTypes = res)
    ).subscribe();
  }
}
